import Enum from "../../../../class/Enum"

export default Enum.make(["CREATED", "VALIDATION_ASKED", "VALIDATED", "REFUSED", "OUT_OF_DATE"]);
